import React from 'react';
import { css } from '@emotion/react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { color } from '@/styles';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const ContentContainer = css`
  width: 480px;
  margin-bottom: 16px;
`;

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

const ContentTitle = css`
  margin-bottom: 2px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3em;
  border-bottom: 3px solid ${color.dark_gray};
`;

const InheritedWidth = css`
  width: inherit;
`;

const InnerRowContainer = css`
  height: 72px;
`;

const Unit = css`
  min-width: 25px;
  font-size: 16px;
  text-align: right;
  margin: 16px 5px 0 5px;
  white-space: nowrap;
`;

const MarginTop = css`
  margin-top: 8px;
`;

export const CareRecordDrinkSection = ({ form }: Props) => {
  const { t } = useTranslation();
  return (
    <div css={[ContentContainer]}>
      <div css={[AlignCenter, ContentTitle]}>{t('waterIntake', '飲水')}</div>
      <div css={[AlignCenter, InnerRowContainer, MarginTop, InheritedWidth]}>
        <TextField
          id={'drink-volume-field'}
          label={t('drinkingVolume', '飲水量')}
          type={'number'}
          value={form.drinkingVolume ?? ''}
          onChange={form.handleChangeDrinkingVolume}
          fullWidth={true}
        />
        <span css={Unit}>ml</span>
      </div>
    </div>
  );
};
